require('./_wks-define')('observable');



/*****************
 ** WEBPACK FOOTER
 ** /Users/endriu/Work/adoratorio/temp/ahs-site/ahs/~/core-js/modules/es7.symbol.observable.js
 ** module id = 271
 ** module chunks = 0
 **/